// Every library link answers with the file as an attachment (the MP4s carry
// Content-Disposition, the data files are sent that way), so loading it in
// this window downloads the file and the page stays where it is, as the Mac
// app download does. The Mac app's window hands it to the browser instead.
export default function openDownload(url) {
  if (typeof window === "undefined" || !url) return false;
  window.location.assign(url);
  return true;
}
